var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechablanca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f9a77a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,21.59a1.44,1.44,0,0,1,.32.91,1,1,0,0,1,0,.33.72.72,0,0,1-.07.25,2.15,2.15,0,0,1-.14.26.77.77,0,0,1-.17.19l-.06.07-5.16,5.15a1.5,1.5,0,0,1-2.12-2.12L26.19,24H15a1.5,1.5,0,0,1,0-3H26.18l-2.67-2.67a1.5,1.5,0,0,1,2.12-2.12l5.19,5.19A1.54,1.54,0,0,1,31,21.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.39,22.5h0A19.9,19.9,0,1,1,22.5,2.6h0A19.9,19.9,0,0,1,42.39,22.5Zm-11.13.33a1,1,0,0,0,0-.33,1.44,1.44,0,0,0-.32-.91,1.54,1.54,0,0,0-.17-.19l-5.19-5.19a1.5,1.5,0,0,0-2.12,2.12L26.18,21H15a1.5,1.5,0,0,0,0,3H26.19l-2.65,2.63a1.5,1.5,0,1,0,2.12,2.12l5.16-5.15.06-.07a.77.77,0,0,0,.17-.19,2.15,2.15,0,0,0,.14-.26A.72.72,0,0,0,31.26,22.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechablanca);
export default __webpack_public_path__ + "static/media/flechablanca.368c5c27b9bbfefd29d63ffb19d12693.svg";
export { ForwardRef as ReactComponent };